import React from "react";
import { IconProps } from "@/icons/icon";

const ArrowRight: React.FC<IconProps> = () => {
  return (
    <svg
      style={{ fill: "currentColor" }}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path d="M10 17l5-5-5-5v10z" />
      <path d="M0 24V0h24v24H0z" fill="none" />
    </svg>
  );
};

export default ArrowRight;
